import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useDocumentDelete = () => {
  return useMutation({
    mutationFn: (data) => api.documents.deleteItem(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось удалить документ',
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Документ успешно удален',
        type: 'success',
      })
    }
  })
}
